import { render } from "./AttributesList.vue?vue&type=template&id=c24bdeda&scoped=true&ts=true"
import script from "./AttributesList.vue?vue&type=script&lang=ts"
export * from "./AttributesList.vue?vue&type=script&lang=ts"

import "./AttributesList.vue?vue&type=style&index=0&id=c24bdeda&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c24bdeda"]])

export default __exports__